import React from 'react';
import ReactDOM from 'react-dom';
import 'react-select/dist/react-select.css';
import StateSearch from '../states/state_search';

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <StateSearch />,
    document.getElementById('state-search')
  );
});
